import { render, staticRenderFns } from "./changeAWBNumberAction.vue?vue&type=template&id=da55c28a&"
import script from "./changeAWBNumberAction.vue?vue&type=script&lang=js&"
export * from "./changeAWBNumberAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports